import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import 'antd/dist/antd.css';
import './index.module.scss';

ReactDOM.render(<App />, document.getElementById("root"));
